import { SUPPORTED_MODEL_TYPES } from "../_shared/domain/SupportedModelTypes";

export const modelTypeToUploaderBoxTitle: { [key in SUPPORTED_MODEL_TYPES]: string } = {
  AEAT_100_RENTA: "documentation_area.docs_ai.models.aeat_100_renta.uploader_box_title",
  AEAT_151_REGIMEN_ESPECIAL:
    "documentation_area.docs_ai.models.aeat_151_regimen_especial.uploader_box_title",
  AEAT_036_CENSO_EMPRESARIOS:
    "documentation_area.docs_ai.models.aeat_036_censo_empresarios.uploader_box_title",
  AEAT_111_IRPF_RENDIMIENTOS_TRABAJO_AUTOLIQUIDACION:
    "documentation_area.docs_ai.models.aeat_111_irpf_rendimientos_trabajo_autoliquidacion.uploader_box_title",
  AEAT_115_IRPF_RENDIMIENTO_INMUEBLES:
    "documentation_area.docs_ai.models.aeat_115_irpf_rendimiento_inmuebles.uploader_box_title",
  AEAT_130_IRPF_DIRECTA:
    "documentation_area.docs_ai.models.aeat_130_irpf_directa.uploader_box_title",
  AEAT_131_IRPF_OBJETIVA:
    "documentation_area.docs_ai.models.aeat_131_irpf_objetiva.uploader_box_title",
  AEAT_180_IRPF_RENDIMIENTO_INMUEBLES_RESUMEN:
    "documentation_area.docs_ai.models.aeat_180_irpf_rendimiento_inmuebles_resumen.uploader_box_title",
  AEAT_190_IRPF_RENDIMIENTOS_TRABAJO_RESUMEN:
    "documentation_area.docs_ai.models.aeat_190_irpf_rendimientos_trabajo_resumen.uploader_box_title",
  AEAT_303_IVA_AUTOLIQUIDACION:
    "documentation_area.docs_ai.models.aeat_303_iva_autoliquidacion.uploader_box_title",
  AEAT_309_IVA_LIQUIDACION_NO_PERIODICA:
    "documentation_area.docs_ai.models.aeat_309_iva_liquidacion_no_periodica.uploader_box_title",
  AEAT_347_OPERACIONES_TERCEROS:
    "documentation_area.docs_ai.models.aeat_347_operaciones_terceros.uploader_box_title",
  AEAT_349_IVA_OPERACIONES_INTRACOMUNITARIAS:
    "documentation_area.docs_ai.models.aeat_349_iva_operaciones_intracomunitarias.uploader_box_title",
  AEAT_200_IMPUESTO_SOCIEDADES:
    "documentation_area.docs_ai.models.aeat_200_impuesto_sociedades.uploader_box_title",
  AEAT_390_IVA_RESUMEN: "documentation_area.docs_ai.models.aeat_390_iva_resumen.uploader_box_title",
  AEAT_714_IMPUESTO_PATRIMONIO:
    "documentation_area.docs_ai.models.aeat_714_impuesto_patrimonio.uploader_box_title",
  AEAT_CERT_CENSAL: "documentation_area.docs_ai.models.aeat_cert_censal.uploader_box_title",
  AEAT_CERT_IRPF: "documentation_area.docs_ai.models.aeat_cert_irpf.uploader_box_title",
  AEAT_CERT_OBLIG_TRIB: "documentation_area.docs_ai.models.aeat_cert_oblig_trib.uploader_box_title",
  AEAT_IRPF_DATOS_FISCALES:
    "documentation_area.docs_ai.models.aeat_irpf_datos_fiscales.uploader_box_title",
  AEAT_DATOS_CENSALES: "documentation_area.docs_ai.models.aeat_datos_censales.uploader_box_title",
  AEAT_DETALLE_DEUDAS: "documentation_area.docs_ai.models.aeat_detalle_deudas.uploader_box_title",
  AEAT_CERT_CENSO_ACTIVIDADES_ECONOMICAS:
    "documentation_area.docs_ai.models.aeat_cert_censo_actividades_economicas.uploader_box_title",
  DGT_VEHICLE_DATA: "documentation_area.docs_ai.models.dgt_vehicle_data.uploader_box_title",
  DGT_INFORME_DATOS_CONDUCTOR:
    "documentation_area.docs_ai.models.dgt_informe_datos_conductor.uploader_box_title",
  SEG_SOCIAL_RESUMEN_SITUACION:
    "documentation_area.docs_ai.models.seg_social_resumen_situacion.uploader_box_title",
  SEG_SOCIAL_BASE_COTIZACIONES:
    "documentation_area.docs_ai.models.seg_social_base_cotizaciones.uploader_box_title",
  SEG_SOCIAL_CERT_INTEGRAL_PRESTACIONES:
    "documentation_area.docs_ai.models.seg_social_cert_integral_prestaciones.uploader_box_title",
  SEG_SOCIAL_CERT_OBLIG:
    "documentation_area.docs_ai.models.seg_social_cert_oblig.uploader_box_title",
  SEG_SOCIAL_VIDA_LABORAL:
    "documentation_area.docs_ai.models.seg_social_vida_laboral.uploader_box_title",
  SEG_SOCIAL_DATOS_TRABAJO_AUTONOMO:
    "documentation_area.docs_ai.models.seg_social_datos_trabajo_autonomo.uploader_box_title",
  SEG_SOCIAL_SITUACION_ACTUAL:
    "documentation_area.docs_ai.models.seg_social_situacion_actual.uploader_box_title",
  SEG_SOCIAL_DATOS_PERSONALES:
    "documentation_area.docs_ai.models.seg_social_datos_personales.uploader_box_title",
  SEG_SOCIAL_DETALLE_DEUDAS:
    "documentation_area.docs_ai.models.seg_social_detalle_deudas.uploader_box_title",
  CARP_CIUD_JUST_EMPADRONAMIENTO:
    "documentation_area.docs_ai.models.carp_ciud_just_empadronamiento.uploader_box_title",
  CARP_CIUD_JUST_AUSENCIA_ANT_PENALES:
    "documentation_area.docs_ai.models.carp_ciud_just_ausencia_ant_penales.uploader_box_title",
  CARP_CIUD_CERT_CATASTRO:
    "documentation_area.docs_ai.models.carp_ciud_cert_catastro.uploader_box_title",
  CARP_CIUD_CERT_NACIMIENTO:
    "documentation_area.docs_ai.models.carp_ciud_cert_nacimiento.uploader_box_title",
  CARP_CIUD_DATOS_PERSONALES:
    "documentation_area.docs_ai.models.carp_ciud_datos_personales.uploader_box_title",
  CARP_CIUD_TITULOS_UNIVERSITARIOS:
    "documentation_area.docs_ai.models.carp_ciud_titulos_universitarios.uploader_box_title",
  CARP_CIUD_TITULOS_NO_UNIVERSITARIOS:
    "documentation_area.docs_ai.models.carp_ciud_titulos_no_universitarios.uploader_box_title",
  NAVARRA_F93: "documentation_area.docs_ai.models.navarra_f93.uploader_box_title",
  VIZCAYA_100_RENTA: "documentation_area.docs_ai.models.vizcaya_100_renta.uploader_box_title",
  GUIPUZCOA_109_RENTA: "documentation_area.docs_ai.models.guipuzcoa_109_renta.uploader_box_title",
  ALAVA_100_RENTA: "documentation_area.docs_ai.models.alava_100_renta.uploader_box_title",
  HACIENDA_RENTA: "documentation_area.docs_ai.models.hacienda_renta.uploader_box_title",
  BDE_CIRBE: "documentation_area.models.bde_cirbe.uploader_box_title",
};
